import axiosService from "./AxiosService.js";

const denominationService = {
  getDenominationsAutocomplete(extraitLibelle) {
    return axiosService.get(
      `/denominations-communes/search?q=${extraitLibelle}`
    );
  },
  getDenominations(recherche, page) {
    let url = recherche
      ? `/denominations-communes/publies?q=${recherche}`
      : "/denominations-communes/publies?";
    if (page) {
      url += "&pageIndex=" + page;
    }
    return axiosService.get(url);
  },
  getDenomination(id) {
    return axiosService.get(`/denominations-communes/publies/${id}`);
  },
  getBibliographies(id) {
    return axiosService.get(`/denominations-communes/${id}/bibliographies`);
  },
  getControles(id) {
    return axiosService.get(`/denominations-communes/${id}/controles`);
  },
  getEvaluations(id) {
    return axiosService.get(`/denominations-communes/${id}/evaluations`);
  },
  getNormes(id) {
    return axiosService.get(`/denominations-communes/${id}/normes`);
  },
  getEquivalences(id) {
    return axiosService.get(`/denominations-communes/${id}/equivalences`);
  },
  getDomaines(id) {
    return axiosService.get(`/denominations-communes/${id}/domaines`);
  },
};
export default denominationService;
